import { subscriptionBillingMethod, subscriptionStatus } from "../enums";
import { ISubscription } from "../interfaces-and-types";
import { customersDataHelper } from "./customers-data-helper";

export const subscriptionsData: ISubscription[] = [
  {
    id: "a0456-5648cc43-5648cc43-237d0098-1ac3",
    customer: customersDataHelper[0],
    status: subscriptionStatus.active,
    billingMethod: subscriptionBillingMethod.auto,
    productName: "Hauling Services",
    description: "a subscription description",
    price: 5000.55,
    currency: "NGN",
    currencySymbol: "₦",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "b1456-5648cc43-5338cc43-237d0098-1ac3",
    customer: customersDataHelper[1],
    status: subscriptionStatus.active,
    billingMethod: subscriptionBillingMethod.auto,
    productName: "Auto Maintenance",
    description: "a subscription description",
    price: 340.55,
    currency: "USD",
    currencySymbol: "$",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "d2456-5448cc43-5648cc43-237d0098-1ac3",
    customer: customersDataHelper[2],
    status: subscriptionStatus.unpaid,
    billingMethod: subscriptionBillingMethod.send,
    productName: "School Fees",
    description: "a subscription description",
    price: 3600.55,
    currency: "GBP",
    currencySymbol: "£",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a43d-5448c123-5648cc43-237d0098-1ac3",
    customer: customersDataHelper[3],
    status: subscriptionStatus.cancelled,
    billingMethod: subscriptionBillingMethod.auto,
    productName: "Cleaning Services",
    description: "a subscription description",
    price: 3600.55,
    currency: "GBP",
    currencySymbol: "£",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a43d-54483241-5648cc43-237d0098-1ac3",
    customer: customersDataHelper[4],
    status: subscriptionStatus.overdue,
    billingMethod: subscriptionBillingMethod.send,
    productName: "Cleaning Services",
    description: "a subscription description",
    price: 3600.55,
    currency: "GBP",
    currencySymbol: "£",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
  {
    id: "a43d-5448cc43-5648aacc-237d0098-1ac3",
    customer: customersDataHelper[3],
    status: subscriptionStatus.overdue,
    billingMethod: subscriptionBillingMethod.send,
    productName: "Cleaning Services",
    description: "a subscription description",
    price: 3600.55,
    currency: "GBP",
    currencySymbol: "£",
    date: "Mon, Aug 30 2022 11:34 PM",
  },
];
